import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Col, Row, Card } from 'react-bootstrap';
import { db, storage } from '../FireBase'; // Ensure correct path and case
import { collection, getDocs, getDoc, doc, query, where } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import ToastAlert from '../components/ToastAlert';
import { FaPrint } from 'react-icons/fa6';
import { ref, getDownloadURL } from "firebase/storage";
import Loading from '../components/Loading';
import * as XLSX from 'xlsx';

const StatisticesDetailed = () => {
    const { id } = useParams();
    const [scheme, setScheme] = useState(null);
    const [profitLossData, setProfitLossData] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true); // Initialize loading state to true
    const [billedOrders, setBilledOrders] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const schemeId = id;
    const [overallSpends, setOverallSpends] = useState(0);
    const [overallProfits, setOverallProfits] = useState(0);

    useEffect(() => {
        fetchData();
    }, [schemeId]);

    useEffect(() => {
        if (scheme) {
            fetchBilledOrders(); // Fetch orders only after scheme is available
        }
    }, [scheme]);

    const fetchData = async () => {
        setLoading(true); // Set loading to true before fetching data
        await fetchScheme();
        await fetchCustomers();
        await fetchBilledOrders();
        setLoading(false); // Set loading to false after fetching
    };

    const syncData = async () => {
        setToastMessage("Synchronization!!!");
        setToastVariant('warning');
        setShowToast(true);
        await fetchData();
        setToastMessage("Synchronization Complete!!!");
        setToastVariant('success');
        setShowToast(true);
    };

    const fetchScheme = async () => {
        try {
            const schemeDoc = await getDoc(doc(db, 'schemes', schemeId));
            if (schemeDoc.exists()) {
                setScheme({ id: schemeDoc.id, ...schemeDoc.data() });
            } else {
                console.error('Scheme not found');
            }
        } catch (error) {
            console.error('Error fetching scheme:', error);
        }
    };

    const fetchCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

            const subscriptionsData = subscriptionsSnapshot.docs.map(doc => doc.data());
            const customerPromises = subscriptionsData.map(async (subscription) => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', subscription.userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    return {
                        id: userDoc.id, ...userDoc.data(),
                        totalMonths: subscription.totalMonths,
                        monthsPaid: subscription.paidMonths,
                        isActive: subscription.isActive,
                        cusStatus: subscription.status,
                        disProof: subscription.discontinueData?.fileURL || '',
                        disNotes: subscription.discontinueData?.notes || '',
                        Paymentstatus: subscription.payments,
                        Quantity: subscription.quantity,
                    };
                } else {
                    console.log(`No such user document for userId: ${subscription.userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchBilledOrders = async () => {
        try {

            console.log(id)
            const biledOrdersQuery = query(collection(db, 'order-processing'), where('BillingStatus', '==', 'Billed'), where('schemeId', '==', id));
            const biledOrdersSnapshot = await getDocs(biledOrdersQuery);
            const billedOrdersData = biledOrdersSnapshot.docs.map(doc => {
                const order = { id: doc.id, ...doc.data() };
                order.totalPrice = order.products.reduce((total, product) => total + (product.price * product.quantity), 0); // Calculate the total price
                order.profit = scheme.totalSchemeValue - order.totalPrice ; // Calculate the profit
                return order;
            });
    
            // Calculate overall spends and overall profits
            const totalSpends = billedOrdersData.reduce((total, order) => total + order.totalPrice, 0);
            const totalProfits = billedOrdersData.reduce((total, order) => total + order.profit, 0);
                console.log(billedOrdersData)
            setBilledOrders(billedOrdersData);
            setOverallSpends(totalSpends);
            setOverallProfits(totalProfits);
            console.log(billedOrdersData);
        } catch (error) {
            console.error('Error fetching billed orders:', error);
        }
    };

    const handlePrintSlip = async (order) => {
        try {
            const storageRef = ref(storage, `deliverySlips/${order.customerId}_${order.schemeId}.pdf`);
            const deliverySlipURL = await getDownloadURL(storageRef);
            window.open(deliverySlipURL, '_blank');
        } catch (error) {
            console.error('Error fetching delivery slip:', error);
            setToastMessage('Error fetching delivery slip. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    const downloadReport = () => {
        // Data for the summary sheet
        const summaryData = [
            ['Overall Spends', overallSpends],
            ['Overall Profits', overallProfits],
            ['Total Users', customers.length],
            ['Scheme Name', scheme.name],
            ['Scheme ID', scheme.schemeId],
            ['Price per Month', scheme.price],
            ['Duration Months', scheme.schemeDuration],
            ['Total Scheme Value', scheme.totalSchemeValue],
            ['Overall Value', scheme.totalSchemeValue * customers.length]
        ];
    
        // Data for the customer-wise sheet
        const customerData = billedOrders.map(order => ({
            'Customer ID': order.customerId,
            'Scheme ID': order.schemeId,
            'Spends': order.totalPrice,
            'Profit': order.profit,
        }));
    
        // Create a new workbook
        const wb = XLSX.utils.book_new();
    
        // Create the summary sheet
        const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
        XLSX.utils.book_append_sheet(wb, wsSummary, 'Summary');
    
        // Create the customer-wise sheet
        const wsCustomer = XLSX.utils.json_to_sheet(customerData);
        XLSX.utils.book_append_sheet(wb, wsCustomer, 'Customer Data');
    
        // Write the workbook to a file
        const fileName = `${scheme.name}_${new Date().toLocaleDateString()}.xlsx`;
        XLSX.writeFile(wb, fileName);
    };
    return (
        <Container fluid className="p-4">
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <h2>Scheme Statistics</h2>
            {loading ? (
                <Loading/>// Show a loading message or spinner while data is being fetched
            ) : (
                scheme && (
                    <div>
                        <Row>
                            <Col>
                                <h1>{scheme.name}</h1>
                                <h3>{scheme.schemeId}</h3>
                            </Col>
                            <Col className="text-end">
                                <Button variant='outline-success' className='m-2' onClick={syncData}>Sync</Button>
                                <Button variant='outline-primary' className='m-2' onClick={downloadReport}>Download Report</Button>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col md={2} sm={2} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{scheme.price}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Price per month</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={2} sm={2} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{scheme.schemeDuration}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Duration months</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={2} sm={2} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{scheme.totalSchemeValue}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Total value</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={2} sm={2} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{customers.length}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Total user</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={4} sm={4} className="mb-4">
                                <Card className="h-100" style={{ backgroundColor: "#3f7936" }}>
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count" style={{ color: 'white' }}>{scheme.totalSchemeValue * customers.length}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head" style={{ color: 'white' }}>Overall Value</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={6} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{overallSpends}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Overall Spends</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} sm={6} className="mb-4">
                                <Card className="h-100">
                                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                        <Card.Text>
                                            <h1 className="cus-count">{overallProfits}</h1>
                                        </Card.Text>
                                        <Card.Title>
                                            <center>
                                                <h5 className="cus-head">Overall Profits</h5>
                                            </center>
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Card className="mb-4">
                            <Card.Body>
                                <div >
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr className='scheme-det-font-head'>
                                                <th>Customer ID</th>
                                                <th>Scheme ID</th>
                                                <th>Spends</th>
                                                <th>Profit</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {billedOrders.length > 0 ? (
                                                billedOrders.map((order, index) => (
                                                    <tr key={index} className='scheme-det-font'>
                                                        <td>{order.customerId}</td>
                                                        <td>{order.schemeId}</td>
                                                        <td>{order.totalPrice}</td>
                                                        <td>{order.profit}</td>
                                                        <td>
                                                            <Button variant="outline-secondary" style={{ marginLeft: '5px' }} className='btn btn' onClick={() => handlePrintSlip(order)}>
                                                                <FaPrint /> View Slip
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5">No billed orders found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                )
            )}
        </Container>
    );
};

export default StatisticesDetailed;